import PropTypes from 'prop-types'
import { REWARDS_TYPES } from './constants'

export const ProductItemPropTypes = PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    price: PropTypes.number,
    is_bought: PropTypes.bool.isRequired,
})

export const ProductPropTypes = PropTypes.shape({
    is_available_to_buy: PropTypes.bool.isRequired,
    groups: PropTypes.objectOf(
        PropTypes.arrayOf(ProductItemPropTypes).isRequired,
    ),
})

export const TankPropTypes = PropTypes.shape({
    type: PropTypes.oneOf(['heavyTank', 'mediumTank', 'lightTank', 'SPG', 'AT-SPG']).isRequired,
    nation: PropTypes.oneOf([
        'ussr', 'germany', 'usa', 'china', 'france', 'uk', 'japan', 'czech', 'sweden', 'poland', 'italy',
    ]).isRequired,
    userName: PropTypes.string.isRequired,
    typeUserName: PropTypes.string.isRequired,
    level: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]).isRequired,
    vehicleId: PropTypes.number.isRequired,
    isPremium: PropTypes.bool.isRequired,
    inHangar: PropTypes.bool,

    clipFireRate: PropTypes.array,
    turretArmor: PropTypes.array.isRequired,
    reloadTime: PropTypes.number,
    health: PropTypes.number.isRequired,
    avgDamage: PropTypes.array.isRequired,
    piercingPower: PropTypes.array.isRequired,
    hullArmor: PropTypes.array.isRequired,
})

export const RewardPropTypes = PropTypes.shape({
    id: PropTypes.number.isRequired,
    token: PropTypes.number.isRequired,
    type: PropTypes.oneOf(Object.values(REWARDS_TYPES)).isRequired,
    infoUrl: PropTypes.string,
    isSelected: PropTypes.bool.isRequired,
    price: PropTypes.number,
    secondCurrency: PropTypes.string.isRequired,
    secondPrice: PropTypes.number.isRequired,
    vehicleParams: TankPropTypes,
})


export const RewardsMetaPropTypes = PropTypes.shape({
    purchaseDatetimeEnd: PropTypes.string.isRequired,
    minBet: PropTypes.number,
    currentBet: PropTypes.number,
    places: PropTypes.number.isRequired,
    famePoints: PropTypes.number,
    hasAuctionTicket: PropTypes.bool,
})

export const BalancePropTypes = PropTypes.shape({
    gold: PropTypes.number.isRequired,
    credits: PropTypes.number.isRequired,
    crystal: PropTypes.number.isRequired,
    walletStatus: PropTypes.shape({
        gold: PropTypes.string.isRequired,
        credits: PropTypes.string.isRequired,
        crystal: PropTypes.string.isRequired,
    }),
    isWGMoneyAvailable: PropTypes.bool.isRequired,
})



// WEBPACK FOOTER //
// ./containers/WGCWXShop/propTypes.js